export default __webpack_public_path__ + "static/media/SYR.dffaa7fe.svg";